var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"items-per-page":-1,"hide-default-footer":"","sort-by":"date"},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("formatDate")(item.date))+" ")]}},{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('holiday-actions',{attrs:{"id":item},on:{"edit":_vm.edit,"remove":_vm.remove}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }